<template>
  <div class="layout-padding" :class="{'modalpage':page!==undefined}">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="공간 파트너 조회"
      desc="서비스에 등록된 공간 파트너들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end" v-if="page===undefined">
      <button style="width:120px"
        @click="$router.push('partner/create')" class="button is-primary">공간 파트너 등록</button>
    </div>

    <div class="btn-group-justify-end" v-else>
      <button @click="selectPartners" class="button is-primary">공간 파트너 선택</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props" v-if="page!==undefined">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="detailLink(props.item.id)">{{ props.item.name }}</span>
      </div>

      <div slot="first_img" slot-scope="props">
        <div style="display: inline-block; text-align: center"
             :style="thumbImgField(props.item.first_img)" v-if="props.item.first_img"></div>
      </div>

      <div slot="partner_admin_name" slot-scope="props">
        {{ props.item.partner_admin?props.item.partner_admin.name:'' }}
      </div>

      <div slot="partner_admin_email" slot-scope="props">
        {{ props.item.partner_admin?props.item.partner_admin.email:'' }}
      </div>

      <div slot="partner_admin_phone" slot-scope="props">
        {{ props.item.partner_admin?props.item.partner_admin.phone:'' }}
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half" style="margin-right:4px" @click.stop.prevent="clickPartner(props.item,'update')">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickPartner(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import BreadCrumb from '../../module/common/BreadCrumb'
  import LpModal from '../../module/common/LpModal'

  import AdminTable from "../../module/admin/AdminTable";
  import AdminFilter from "../../module/admin/AdminFilter";
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'PartnerList',
    layout: 'Main',
    mixins: [
      ListMixin
    ],
    props: {
      page: {
        type: String,
        default: undefined
      },
      selectedItems: {
        type: Array
      }
    },
    components: {
      LpCheckBool,
      AdminFilter,
      AdminTable,
       LpSortDropDown, LpInputText, LpRadio,
      LpModal
    },
    data() {
      return {
        // 삭제시킬 번호
        modalPartner: 0
      }
    },
    created () {
      this.init();
      if(this.page!==undefined) {
        if(this.tableData[0].eng_name !== 'checkspot') {
          this.tableData.splice(0, 0, {
            eng_name: 'checkspot',
            ko_name: '',
            width: '47px'
          });
        }
      }
    },
    methods: {
      init() {
        this.initializing('space_partner', 'space/partner');
        this.filtered.space = true;
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      selectPartners () {
        let tableItems = [];
        let id_list = [];
        for(let i=0; i<this.showcaseCheckArr.length; i++){
          for(let j=0; j<this.tableItems.length; j++){
            if(this.showcaseCheckArr[i].value && this.showcaseCheckArr[i].id===this.tableItems[j].id){
              tableItems.push(this.tableItems[j]);
              id_list.push(this.tableItems[j].id);
            }
          }
        }
        //console.log(tableItems)
        this.$emit('tableItems', {
          tableItems: tableItems,
          id_list: id_list
        });
      },
      detailLink(id) {
        this.$router.push(this.getPath(`space/partner/create?id=${id}`))
      },
      clickPartner(item, types) {
        if (types === 'update') {
          this.$router.push(this.getPath('space/partner/create?id=' + item.id));
        }
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'space/partner/',
            title: '파트너를 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
          // this.modalPartner = item.id;
          // this.$refs.deleteModal.open();
        }
      },
      delPartner() {
        this.$axios.delete(this.getUrl('space/partner/') + this.modalPartner)
          .then(res => {
            if (res.status === 200) {
              this.$refs.deleteModal.close();
              this.getData();
              this.toast('파트너가 삭제되었습니다.');
            }
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .td-btn
    cursor pointer

  .td-btn:hover
    background-color #caf6ec
    font-weight bold
    font-size 1rem
    color $primary

  .prod-list-page-selected
    color #18a4ed

  .prod-list-page-not-selected
    color #666

  .primary
    color $primary

  .modalpage
    margin-top 50px
    padding 1.25rem


</style>
